import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { X } from "lucide-react";
import { Button } from "react-bootstrap";

import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { notifyError, notifySuccess } from "../../utils/helper";
import { addFaqs } from "../../requests";
import { useDispatch } from "react-redux";
import styles from "../../_css/ContenetManagement.module.css";

const AddFaqsModal = ({ show, onHide, onSuccess }) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [url, setUrl] = useState("");
    const [isHovered, setIsHovered] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const handleSave = async (status) => {
        // Validation
        if (!title.trim()) {
            notifyError("Please enter a title");
            return;
        }
        if (!description.trim()) {
            notifyError("Please enter a description");
            return;
        }

        try {
            dispatch(startLoader());
            setIsLoading(true);

            const payload = {
                question: title.trim(),
                answer: description.trim(),
                status: status
            };

            const response = await addFaqs(payload);


            notifySuccess(`FAQ ${status === "Published" ? "published" : "saved as draft"} successfully`);

            if (onSuccess) onSuccess();
            onHide();
            setTitle("");
            setDescription("");
            setUrl("");

        } catch (err) {
            console.error("Failed to add FAQ:", err);
            notifyError(err.response?.data?.message || "Failed to add FAQ. Please try again.");
        } finally {
            dispatch(stopLoader());
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        if (!isLoading) {
            onHide();
            setTitle("");
            setDescription("");
            setUrl("");
        }
    };

    const handleDraftSave = () => {
        if (!isLoading) {
            handleSave("Draft");
        }
    };

    const handlePublish = () => {
        if (!isLoading) {
            handleSave("Published");
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered dialogClassName="modal-38">
            <Modal.Body className={isLoading ? styles.loading : ""}>
                <div className={styles.modalContainer}>
                    <div className={styles.AddFaqHeader}>
                        <X
                            onClick={handleClose}
                            className={styles.closeIcon}
                            size={24}
                        />
                        <span className={styles.addFaqTitle}>
                            Add FAQs
                        </span>
                    </div>

                    {/* Title */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Title</label>
                        <input
                            type="text"
                            placeholder="How to start roleplay"
                            className={`${styles.input} ${styles.placeholder}`}
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            disabled={isLoading}
                        />
                    </div>

                    {/* Description */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Description</label>
                        <textarea
                            placeholder="PractAIce is a platform designed to enhance employee skills..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={3}
                            disabled={isLoading}
                            className={`${styles.textarea} ${styles.placeholder}`}
                        />
                    </div>

                    {/* Upload URL */}
                    {/* <div className={styles.formGroup}>
                        <label className={styles.label}>or Upload the URL</label>
                        <div className={styles.urlContainer}>
                            <input
                                type="text"
                                placeholder="https://example.com/faq"
                                value={url}
                                onChange={(e) => setUrl(e.target.value)}
                                disabled={isLoading}
                                className={`${styles.urlInput} ${styles.placeholder}`}
                            />
                            <button
                                className={styles.uploadButton}
                                onMouseEnter={() => !isLoading && setIsHovered(true)}
                                onMouseLeave={() => !isLoading && setIsHovered(false)}
                                disabled={isLoading}
                            >
                                Upload
                            </button>
                        </div>
                    </div> */}

                    {/* Buttons */}
                    <div className={styles.buttonContainer}>
                        <button
                            className={styles.draftButton}
                            onClick={handleDraftSave}
                            disabled={isLoading}
                        >
                            {isLoading ? "Saving..." : "Save As Draft"}
                        </button>
                        <button
                            className={styles.publishButton}
                            onClick={handlePublish}
                            disabled={isLoading}
                        >
                            {isLoading ? "Publishing..." : "Publish"}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddFaqsModal;